import { useDebounceFn, watchImmediate } from '@vueuse/core'
import { MaybeRef, toValue } from 'vue'

export default function (
  element: MaybeRef<HTMLElement | undefined>,
  search: MaybeRef<string>,
  highlightName = 'search',
  debounceMs = 0,
) {
  if (!CSS.highlights) return

  const highlightTextFn = useDebounceFn(highlightText, debounceMs)

  watchImmediate(
    () => [toValue(element), toValue(search)] as any,
    ([elementValue, searchValue]: [HTMLElement, string]) => {
      highlightTextFn(elementValue, searchValue, highlightName)
    },
  )
}

function highlightText(element: HTMLElement, text: string, highlightName: string) {
  if (!CSS.highlights) return
  if (!element || !highlightName) return
  if (!text) {
    CSS.highlights.delete(highlightName)
    return
  }

  const ranges: Range[] = []

  getTextNodesInElementContainingText(element, text).forEach(node => {
    ranges.push(...getRangesForSearchTermInTextNode(node, text))
  })

  CSS.highlights.set(highlightName, new Highlight(...ranges))
}

function getTextNodesInElementContainingText(element: HTMLElement, text: string) {
  const nodes: Node[] = []
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT)
  let node: Node | null = null
  while ((node = walker.nextNode())) {
    if (node.textContent?.toLowerCase().includes(text.toLowerCase())) {
      nodes.push(node)
    }
  }
  return nodes
}

function getRangesForSearchTermInTextNode(textNode: Node, search: string): Range[] {
  const ranges: Range[] = []
  const text = textNode.textContent?.toLowerCase() || ''
  let start = 0
  let index: number
  while ((index = text.indexOf(search.toLowerCase(), start)) >= 0) {
    const range = new Range()
    range.setStart(textNode, index)
    range.setEnd(textNode, index + search.length)
    ranges.push(range)
    start = index + search.length
  }
  return ranges
}
